import { UPDATE_EVER_EXPANDED } from '../actions';

export const everExpanded = (state = false, action) => {
  switch (action.type) {
    case UPDATE_EVER_EXPANDED: {
      return action.everExpanded;
    }
    default:
      return state;
  }
};
